import { render, staticRenderFns } from "./VehicleManufacturer.vue?vue&type=template&id=6a8b3746&scoped=true"
import script from "./VehicleManufacturer.vue?vue&type=script&lang=js"
export * from "./VehicleManufacturer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b3746",
  null
  
)

export default component.exports